import { ChainedSchema } from '../general/ChainedSchema';
class SerializrType_disgardOldValue extends ChainedSchema {
    constructor(propSchema) {
        super(propSchema);
    }
    shouldDisgardOldValue(context) {
        return true;
    }
}
export function disgardOldValue(propSchema) {
    return new SerializrType_disgardOldValue(propSchema);
}
